import { Vector2, Vector3 } from "three";

export class Coordinate {
  static __coordinates: Coordinate[] = [];

  pos: Vector3;
  mass = 1;
  friction = 0.01;
  vel = new Vector3(0, 0, 0);
  acc = new Vector3(0, 0, 0);
  force = new Vector3(0, 0, 0);

  set x(x) {
    this.pos.x = x;
  }

  set y(y) {
    this.pos.y = y;
  }

  set z(z) {
    this.pos.z = z;
  }

  get x() {
    return this.pos.x;
  }

  get y() {
    return this.pos.y;
  }

  get z() {
    return this.pos.z;
  }

  static isCoordinate(obj: any): obj is Coordinate {
    if (obj.hasOwnProperty("__iamcoordinate")) {
      return true;
    }
    const props = ["pos", "mass", "friction", "vel", "acc", "force"];
    return props.reduce((prev, curr) => {
      return obj.hasOwnProperty(curr) && prev;
    }, true);
  }

  __iamcoordinate() { }

  constructor(
    position:
      | number[]
      | Vector2
      | Vector3
      | number
      | Coordinate
      | {
        x: number;
        y: number;
        z?: number;
      },
    positiony?: number,
    positionz?: number,
  ) {
    Coordinate.__coordinates.push(this);
    if (typeof position === "number" && typeof positiony === "number") {
      this.pos = new Vector3(position as number, positiony, positionz ?? 0);
      return;
    }
    if (Coordinate.isCoordinate(position)) {
      this.pos = new Vector3(position.pos.x, position.pos.y, position.pos.z);
      this.vel = new Vector3(position.vel.x, position.vel.y, position.vel.z);
      this.acc = new Vector3(position.acc.x, position.acc.y, position.acc.z);
      this.force = new Vector3(
        position.force.x,
        position.force.y,
        position.force.z,
      );
      this.mass = position.mass;
      this.friction = position.friction;
      return;
    }
    if (Array.isArray(position)) {
      this.pos = new Vector3(position[0], position[1], position[2] ?? 0);
      return;
    }
    if (typeof position === "object") {
      this.pos = new Vector3(position.x, position.y, (position as any).z ?? 0);
      return;
    }
    try {
      this.pos.copy(position as any as Vector3);
    } catch (err) {
      try {
        this.pos = new Vector3(
          (position as any as Vector2).x,
          (position as any as Vector2).y,
          0,
        );
      } catch (err) {
        throw (
          "Coordinate expects an array [X, Y, Z], an object" +
          " {x:X, y:Y, z:Z} or a Three.js Vector3 Object. " +
          "Got (" +
          JSON.stringify(position) +
          ")"
        );
      }
    }
  }

  static Animate(timeVariance: number) {
    for (let coord of Coordinate.__coordinates) {
      coord.acc.addScaledVector(coord.force, timeVariance / coord.mass);
      coord.vel.addScaledVector(coord.acc, timeVariance);
      coord.pos.addScaledVector(coord.vel, timeVariance);
      coord.force.multiplyScalar(0);
      // Friction
      coord.acc.multiplyScalar(timeVariance * coord.friction);
    }
  }
}
